import React from "react";
import { BottomSheet } from "@nykaa/payment-ui/src/BottomSheet/BottomSheet";
import { CouponBottomSheetProps } from "./CouponBottomSheet.types";
import { useTheme } from "emotion-theming";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import {
  CouponCodeWrapper,
  CouponDetailsWrapper,
  FooterWrapper,
  LabelWrapper,
  LogoWrapper,
  TncList,
  TnCListItem,
  TnCWrapper,
} from "./assets/CouponBottomSheet.styles";
import { Text } from "@nykaa/payment-ui/src/Text";
import { Image } from "@nykaa/payment-ui/src/Image";
import { FilledButton } from "@nykaa/payment-ui/src/Button";
import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";
import { VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { getStringFromId } from "helpers/vernacular";


export const CouponBottomSheet = ({
  isVisible,
  onClose,
  couponCode,
  couponImage,
  couponTitle,
  couponSubTitle,
  couponTnC,
  isApplied,
  onApplyCoupon,
  title,
}: CouponBottomSheetProps) => {
  const theme: Theme = useTheme();

  const couponApplyCTA = getStringFromId(VERNACULAR_STRING_IDS.COUPON_APPLY_CTA, VERNACULAR_DEFAULT_MESSAGES.COUPON_APPLY_CTA);
  const couponDismissCTA = getStringFromId(VERNACULAR_STRING_IDS.COUPON_DISMISS_CTA, VERNACULAR_DEFAULT_MESSAGES.COUPON_DISMISS_CTA);
  const couponApplied = getStringFromId(VERNACULAR_STRING_IDS.COUPON_APPLIED, VERNACULAR_DEFAULT_MESSAGES.COUPON_APPLIED);

  return (
    <BottomSheet
      isVisible={isVisible}
      onClose={onClose}
      leadingIcon={getIcons(__PLATFORM__, ICONS_NAMES.CLEAR_WHITE)}
      bannerUrl={getIcons(__PLATFORM__, ICONS_NAMES.PAYMENT_HEADER_BACKGROUND)}
      isNewBottomSheetDesign
      onIconClick={onClose}
      noContentPadding
      theme={theme}
    >
      <>
        {title && (
          <LabelWrapper>
            {!isApplied && (
              <Text
                text="Apply and"
                font={theme?.typography?.type202}
                color={theme?.colors?.textPrimary}
              />
            )}
            {isApplied && <Image url={getIcons(__PLATFORM__, ICONS_NAMES.ALERT_POSITIVE)} />}
            <Text text={title} font={theme?.typography?.type202} color={theme?.colors?.positive} />
          </LabelWrapper>
        )}
        <CouponDetailsWrapper>
          <LogoWrapper>
            <Image
              url={couponImage || getIcons(__PLATFORM__, ICONS_NAMES.HEADER_LOGO)}
              alt="Coupon Logo"
            />
          </LogoWrapper>
          <div>
            {couponTitle && (
              <Text
                text={couponTitle}
                font={theme?.typography?.type162}
                color={theme?.colors?.textPrimary}
              />
            )}
            {couponSubTitle && (
              <Text
                text={couponSubTitle}
                font={theme?.typography?.type140}
                color={theme?.colors?.textSecondary}
              />
            )}
          </div>
        </CouponDetailsWrapper>
        {couponTnC?.length > 0 && (
          <TnCWrapper>
            <Text
              text="Terms and Conditions"
              font={theme?.typography?.type122}
              color={theme?.colors?.textPrimary}
            />
            <TncList>
              {couponTnC.map((tnc, index) => (
                <TnCListItem key={index}>{tnc}</TnCListItem>
              ))}
            </TncList>
          </TnCWrapper>
        )}
        <CouponCodeWrapper>
          <Text
            text={couponCode}
            font={theme?.typography?.type142}
            color={theme?.colors?.textSecondary}
          />
          {isApplied && (
            <Text
              text={couponApplied}
              font={theme?.typography?.type141}
              color={theme?.colors?.positive}
            />
          )}
        </CouponCodeWrapper>
        <FooterWrapper>
          <FilledButton
            text={isApplied ? couponDismissCTA : couponApplyCTA}
            onClick={isApplied ? onClose : onApplyCoupon}
            buttonType="medium"
          />
        </FooterWrapper>
      </>
    </BottomSheet>
  );
};
